import { render, staticRenderFns } from "./SettingsBotConvertToMultiMarketDialog.vue?vue&type=template&id=b0773162&"
import script from "./SettingsBotConvertToMultiMarketDialog.vue?vue&type=script&lang=js&"
export * from "./SettingsBotConvertToMultiMarketDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports